import styled from "styled-components";
import { typography } from "src/utils/styledComponents/typography";

/**
 * One field, one definition.
 *
 * These were the product's second field: a 5px box inside a FULL accent
 * border, under an accent label at 13px — so the deposit dialog put a
 * hairline select and an accent-ringed amount input one row apart, and the
 * top-up dialog did the same. The forms in `components/Form` already carry
 * the field the design system settled on (white on a hairline, the accent
 * kept for focus, an ink label with 6px of clearance), so this module hands
 * those on rather than restating them slightly differently.
 */
export {
  Input,
  InputNumber,
  Label,
  Text,
  TextArea,
  FieldError,
} from "src/components/Form/styles/form";

/** The only piece this module still owns: the "(optional)" tail on a label. */
export const Optional = styled.span`
  color: #00000080;
  opacity: 0.8;
  ${typography.CustomText("0.75rem")}
  font-weight: 500;
`;
